export default "__VITE_ASSET__CHcVUbQm__"